export { default as UiFooterNav } from "./UiFooterNav";
